import client from './client';

// Get home page
export async function getHomePage() {
  try {
    // First try to get content types to find the actual ID
    const contentTypes = await client.getContentTypes();
    const pageType = contentTypes.items.find(ct => ct.name === 'Page' || ct.sys.id.includes('page'));
    const pageContentTypeId = pageType ? pageType.sys.id : 'page';
    
    const entries = await client.getEntries({
      content_type: pageContentTypeId,
      'fields.isHome': true,
      include: 10, // Include linked entries (sections, etc.)
    });
    
    if (entries.items.length === 0) {
      throw new Error('No home page found. Make sure you have a page with isHome=true in Contentful.');
    }
    
    const page = entries.items[0];
    
    return page;
  } catch (error) {
    console.error('Error fetching home page:', error);
    throw error;
  }
}

// Get page by slug
export async function getPageBySlug(slug) {
  try {
    // First try to get content types to find the actual ID
    const contentTypes = await client.getContentTypes();
    const pageType = contentTypes.items.find(ct => ct.name === 'Page' || ct.sys.id.includes('page'));
    const pageContentTypeId = pageType ? pageType.sys.id : 'page';
    
    const entries = await client.getEntries({
      content_type: pageContentTypeId,
      'fields.slug': slug,
      include: 10,
    });
    
    if (entries.items.length === 0) {
      return null;
    }
    
    return entries.items[0];
  } catch (error) {
    console.error(`Error fetching page with slug "${slug}":`, error);
    throw error;
  }
}

// Get navigation menu
export async function getNavigationMenu() {
  try {
    // First try to get content types to find the actual ID
    const contentTypes = await client.getContentTypes();
    const menuType = contentTypes.items.find(ct => ct.name === 'Navigation Menu' || ct.sys.id.includes('navigationMenu'));
    const menuContentTypeId = menuType ? menuType.sys.id : 'navigationMenu';
    
    const entries = await client.getEntries({
      content_type: menuContentTypeId,
      include: 5,
    });
    
    if (entries.items.length === 0) {
      return null;
    }

    return entries.items[0];
  } catch (error) {
    console.error('Error fetching navigation menu:', error);
    return null;
  }
}

// Get site settings
export async function getSiteSettings() {
  try {
    // First try to get content types to find the actual ID
    const contentTypes = await client.getContentTypes();
    const settingsType = contentTypes.items.find(ct => ct.name === 'Site Settings' || ct.sys.id.includes('siteSettings'));
    const settingsContentTypeId = settingsType ? settingsType.sys.id : 'siteSettings';
    
    const entries = await client.getEntries({
      content_type: settingsContentTypeId,
    });
    
    if (entries.items.length === 0) {
      return null;
    }
    
    return entries.items[0];
  } catch (error) {
    console.error('Error fetching site settings:', error);
    return null;
  }
}

